export const isSummaryTransactionType = (transactionType) =>
  typeof transactionType === "string" &&
  transactionType.length === 20 &&
  transactionType.charAt(4) === "1";
